export default __webpack_public_path__ + "static/media/toggle-icon.2454d37f.svg";